import React from 'react';
import MenuMain from '../../MenuMain';
import { FormPessoa } from '../../components/FormPessoa';
import { AppFooter } from '../../AppFooter';


export default function CadastrarPessoaPage() {

  const defaultValues = {
    'nome': '',
    'cpf': '',
    'numero_instalacao': '',
    'arquivo': '',
    'rural': true,
    'endereco_ou_fazenda': '',
    'bairro_ou_distrito': '',

  }

  return (
    <div>
      <MenuMain>
         <FormPessoa
          defaultValues={defaultValues}
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}

